import React from "react";
import { useNavigate } from "@tanstack/react-router";
import { Heading } from "@tennr/frontend/components/Heading";
import { Button } from "@tennr/frontend/components/Button";
import { MetadataTags } from "@tennr/frontend/components/MetadataTags";
import "./ErrorPage.css";

export interface ErrorPageProps {
  title: string;
  heading: string;
  body: string;
  metaTitle: string;
  metaDescription: string;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({ 
  title,
  heading,
  body,
  metaTitle,
  metaDescription
}) => {
  const navigate = useNavigate();

  return (
    <>
      <MetadataTags title={metaTitle} description={metaDescription} />
      <main className="error-page">
        <section className="error-section section-y">
          <Heading
            title={title}
            heading={heading}
            body={body}
            variant="section"
            position="center"
            color="dark"
            width={730}
            mobilePosition="center"
            verticalAlign="top"
          />
          <div className="error-button-wrapper">
            <Button text={"HOME"} onClick={() => navigate({ to: "/" })} />
          </div>
        </section>
      </main>
    </>
  );
};